<template>
    <router-view></router-view>
</template>

<script>
export default {
name: "actionPlan"
}
</script>

<style scoped>

</style>